import { Icons } from '@/app/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export type Color = 'primary' | 'secondary' | 'tertiary' | 'transparent' | 'lightblue' | 'green-600' | 'red-600' | 'warning' | 'gray' | 'red-900';
export type ColorTexto = 'primary' | 'secondary' | 'tertiary' | 'white' | 'black' | 'danger' | 'success' | 'warning';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
  imports: [CommonModule, FormsModule],
  standalone: true,
})
export class ButtonComponent {
  @Input() texto = 'Ingresar texto';
  @Input() colorTexto: ColorTexto = 'primary';
  /** El icono del botón */
  @Input() icon!: Icons;
  /** Define la dirección del botón */
  @Input() alineamiento: 'izq' | 'der' | 'cen' = 'der';

  @Input() desactivado = false;

  @Input() color: Color = 'primary';

  @Output() clickBtn = new EventEmitter<boolean>();

  @Input() rounded: boolean = false;
  @Input() primeIcon!: string;
  @Input() small = false;
  @Input() borderBottom: boolean = false;

  onClick() {
    this.clickBtn.emit(true);
  }
}
